// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3n1Mh","checkboxCol":"Table_checkboxCol__1XWQq","emailCol":"Table_emailCol__huWPJ","actionCol":"Table_actionCol__12biU"};